/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncWhatsAppTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_whatsapp_templates`);
  }

  createWhatsAppTemplate(inboxId, templateData, isFormData = false) {
    if (isFormData) {
      return axios.post(
        `${this.url}/${inboxId}/create_whatsapp_template`,
        templateData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    }
    return axios.post(`${this.url}/${inboxId}/create_whatsapp_template`, {
      template: templateData,
    });
  }

  updateWhatsAppTemplate(
    inboxId,
    templateId,
    templateData,
    isFormData = false
  ) {
    if (isFormData) {
      templateData.append('template_id', templateId);
      return axios.put(
        `${this.url}/${inboxId}/update_whatsapp_template`,
        templateData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    }
    return axios.put(`${this.url}/${inboxId}/update_whatsapp_template`, {
      template: templateData,
      template_id: templateId,
    });
  }

  deleteWhatsAppTemplate(inboxId, template) {
    return axios.delete(`${this.url}/${inboxId}/delete_whatsapp_template`, {
      params: {
        template_name: template.name,
      },
    });
  }

  retryWhatsappConnection(inboxId) {
    return axios.post(`${this.url}/${inboxId}/retry_whatsapp_connection`);
  }

  reconnectWhatsapp(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/reconnect_whatsapp`, data);
  }

  resubscribeInstagram(inboxId) {
    return axios.post(`${this.url}/${inboxId}/resubscribe_instagram`);
  }

  getVoiceSoftphone(inboxId) {
    return axios.get(`${this.url}/${inboxId}/voice_softphone`);
  }

  getVoiceConnectorConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/voice_connector_config`);
  }

  updateVoiceConnectorConfig(
    inboxId,
    {
      providerWebhookSecret,
      providerRecordingSecret,
      removeProviderRecordingSecret,
      dialCredential,
      removeDialCredential,
    } = {}
  ) {
    const payload = {};
    if (providerWebhookSecret) {
      payload.provider_webhook_secret = providerWebhookSecret;
    }
    if (providerRecordingSecret) {
      payload.provider_recording_secret = providerRecordingSecret;
    }
    if (removeProviderRecordingSecret === true) {
      payload.remove_provider_recording_secret = true;
    }
    if (dialCredential) payload.dial_credential = dialCredential;
    if (removeDialCredential === true) payload.remove_dial_credential = true;
    return axios.put(`${this.url}/${inboxId}/voice_connector_config`, payload);
  }

  getWithTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}`, {
      params: {
        include_templates: true,
      },
    });
  }
}

export default new Inboxes();
